<template>
    <div>
        <div class="bg--img bg--brands-that-trust-us wash heavy">
            <h1 class="text-center pad-top--xl pad-bottom--xl z-up text-white">
                Check Out - Review Order
            </h1>
        </div>
        <div class="grid-container pad-top--large">
            <div class="grid-x grid-padding-x">
                <div class="cell small-12 medium-4">
                    <div
                        v-for="(item, index) in basket"
                        v-bind:key="index"
                        class="grid-x">
                        <div class="cell small-12 medium-3">
                            <img
                                v-bind:src="`https://our-catalogue.com/RUNS/images/${item.product_code}.jpg?width=100`"
                                alt="" />
                        </div>
                        <div class="cell small-12 medium-6">
                            <p class="small text-light pad-left">
                                {{ item.product_code }}
                            </p>
                            <p class="small text-light pad-left">
                                Colour <span class="float-right">{{ item.colour }}</span><br />
                                Size <span class="float-right">{{ item.size }}</span><br />
                                Method <span class="float-right">{{ item.method }}</span><br />
                                Customize <span class="float-right">{{ item.design_id }}</span><br />
                            </p>
                        </div>
                        <div class="cell small-12 medium-3">
                            <p class="text-right text-heavy">
                                &pound;{{ item.price + ( item.design_price / 100 ) | numeral('0,0.00') }} X {{ item.quantity }}
                            </p>
                        </div>
                        <div class="cell small-12">
                            <hr />
                        </div>
                    </div>
                </div>
                <div class="cell small-12 medium-4">
                    <p v-if="invoiceAddress.name">
                        Invoice address<br />
                        <span v-if="invoiceAddress.name">Name: {{ invoiceAddress.name }}<br /></span>
                        <span v-if="invoiceAddress.email">Email: {{ invoiceAddress.email }}<br /></span>
                        <span v-if="invoiceAddress.contactNumber">Number: {{ invoiceAddress.contactNumber }}<br /></span>
                        Address:
                        <span v-if="invoiceAddress.lineOne">{{ invoiceAddress.lineOne }},</span>
                        <span v-if="invoiceAddress.town">{{ invoiceAddress.town }},</span>
                        <span v-if="invoiceAddress.postCode">{{ invoiceAddress.postCode }}</span>
                    </p>
                    <p v-if="deliveryAddress.postCode">
                        Delivery address
                        {{ deliveryAddress }}
                    </p>
                </div>
                <div class="cell small-12 medium-4">
                    <div
                        v-for="(item, index) in basket"
                        v-bind:key="index"
                        class="grid-x">
                        <div class="cell small-10">
                            <p class="small marg-bottom--none">
                                {{ item.name }}
                            </p>
                        </div>
                        <div class="cell small-2">
                            <p class="text-right small marg-bottom--none">
                                &pound;{{ ((item.price + ( item.design_price / 100 )) * item.quantity) | numeral('0,0.00') }}
                            </p>
                        </div>
                    </div>
                    <table class="fixed">
                        <tbody>
                            <tr>
                                <th>SubTotal</th>
                                <td colspan="2" class="text-right">
                                    &pound;{{ basketSubTotal | numeral('0,0.00') }}
                                </td>
                            </tr>
                            <tr>
                                <th>Delivery</th>
                                <td>&nbsp;</td>
                                <td class="price-cell text-right">
                                    &pound;{{ deliveryPrice | numeral('0,0.00') }}
                                </td>
                            </tr>
                            <tr>
                                <th>Total</th>
                                <td colspan="2" class="text-right">
                                    &pound;{{ (deliveryPrice + basketSubTotal) | numeral('0,0.00') }}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <h5 class="text-green text-center pad-top--small">
                        <img class="nudge-up" width="25" src="../../../static/images/icons/checked.png" alt="" />&nbsp;Payment done
                    </h5>
                    <hr />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Review',
    computed: {
        deliveryAddress() { return this.$store.getters.deliveryAddress; },
        invoiceAddress() { return this.$store.getters.invoiceAddress; },
        basket() { return this.$store.getters.basketItems; },
        basketSubTotal() { return this.$store.getters.basketSubTotal; },
        deliveryPrice() { return this.$store.getters.deliveryPrice; },
    },
    methods: {
        sendGtag() {
            this.$gtag.event('conversion', {
                send_to: 'AW-663912145/Dt0GCMThgbwYENH9ybwC',
                value: 1.0,
                currency: 'GBP',
                transaction_id: this.orderId,
            });
        },
    },
    mounted() {
        this.sendGtag();
    },
};
</script>



// WEBPACK FOOTER //
// src/components/CheckOut/Thankyou.vue